import {
  resolveAccessTokenFromStorage,
  useAccessTokenContext,
} from '../../context/accessTokenContext';

/**
 * Returns the current access token.
 *
 * Context-first: when an `AccessTokenProvider` supplies a token it wins.
 * Otherwise falls back to storage — the path taken on patient flows where
 * Frontegg is never mounted (PROD-8068). Returns an empty string when neither
 * source has a token.
 */
export const useGetAccessToken = (): string => {
  const contextToken = useAccessTokenContext();

  return contextToken ?? resolveAccessTokenFromStorage();
};
